import React from 'react';
import styled from 'styled-components';
import { Checkbox } from './checkbox';

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 5px;
`;
const StyledNotAvailableLabel = styled.span`
  flex-shrink: 0;
  color: ${props => props.theme.colors.midGrey};
  font-size: ${props => props.theme.fontSize.xs};
  margin-left: ${props => props.theme.spacing.sm};
  padding-top: ${props => props.theme.spacing.xs};
`;

export const CustomVMCheckbox = ({
  labelText,
  notAvailableText,
  ...props
}: any) => (
  <StyledContainer>
    <Checkbox {...props}>{labelText}</Checkbox>
    {notAvailableText && (
      <StyledNotAvailableLabel>{notAvailableText}</StyledNotAvailableLabel>
    )}
  </StyledContainer>
);
